<template>
  <div>
    <v-row dense>
      <v-col cols="12" md="8" offset-md="2" v-if="!loading && student">
        <student-form
          :isCreateMode="true"
          :student="student"
          :formTitle="descriptions.register_new_student"
          @save="onSave"
        ></student-form>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import StudentForm from "@/components/students/StudentForm.vue"
import Student from "@/models/Student"
import Description from "@/models/Description"
import { mapGetters } from "vuex"

export default {
  async mounted() {
    this.createStudent()
    axios
      .get("/api/v1/languages")
      .then((response) => {
        this.languages = response.data
      })
      .catch((error) => {
        console.log(error)
      })
  },
  data() {
    return {
      tab: null,
      loading: false,
      languages: [],
      isEditMode: false,
      student: null,
    }
  },
  components: {
    StudentForm,
  },
  methods: {
    async onSave(newStudent) {
      this.loading = true
      await Student.post(newStudent).then((orm) => {
        this.$router.push({
          path: "/students/" + orm.response.data.data.id,
          query: {
            create_mode: true,
          },
        })
      })
    },
    createStudent() {
      this.student = new Student()
    },
  },
  computed: {
    ...mapGetters("Auth", ["isAdmin", "isProfessor"]),
    spokenLanguages() {
      if (this.student.langs?.length) {
        const filteredValues = this.student.langs.map((lang) => this.languages[lang])
        return filteredValues.join(", ")
      } else {
        return ""
      }
    },
    descriptions() {
      return Description.every()
    },
  },
}
</script>
